import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { ChatNotificationService } from 'src/app/services/chat-notification.service';
import { SignalRService } from 'src/app/services/signalR.service';
import { TranslateConfigService } from 'src/app/services/translate-config.service';
import { User1Service } from 'src/app/services/user1.service';
import { VoiceCommsService } from 'src/app/services/voice-comms.service';
import { Role } from 'src/app/shared/role';
// import { AuthService } from 'src/app/services/api/auth.service';
// import { User1Service } from 'src/app/services/api/user1.service';
// import { TranslateConfigService } from 'src/app/services/translate-config.service';
// import { System } from 'src/app/services/utils/constants';
// import { Role, Status } from 'src/app/shared/role';
import { environment } from 'src/environments/environment';
// import { LanguageComponent } from '../language/language.component';

@Component({
  selector: 'rfr-vertical-menu',
  templateUrl: './rfr-vertical-menu.component.html',
  styleUrls: ['./rfr-vertical-menu.component.scss'],
})
export class RfrVerticalMenuComponent implements OnInit {
  @Output() themeSelected = new EventEmitter<string>();
  @Output() action = new EventEmitter<string>();
  languages: any;
  lang: any;
  menus: any[] = [];
  informationMenus: any[] = [];
  digitalMenus: any[] = [];
  physicalMenus: any[] = [];
  globalSettingMenus: any[] = [];

  hasNewGroupMessage: any;
  hasNewChatMessage: any;

  constructor(
    private authService: AuthService,
    private modalController: ModalController,
    private alertCtrl: AlertController,
    private userService: User1Service,
    private translateService: TranslateConfigService,
    private router: Router,
    private signalRService: SignalRService,
    private chatNotificationService: ChatNotificationService,
    private voiceCommsService: VoiceCommsService
  ) {}

  ngOnInit() {
    this.menus = [];
    if (this.authService.hasRole(Role.SystemAdmin))
      this.menus = [...this.getSystemAdminMenu()];
    else if (
      this.authService.hasRole(Role.Client) ||
      this.authService.hasRole(Role.Seeker)
    )
      this.menus = [...this.getClientMenu()];
    else this.menus = [...this.getKnightMenu()];

    this.chatNotificationService.hasNewGroupMessage$.subscribe((state: any) => {
      this.hasNewGroupMessage = state;
    });

    this.chatNotificationService.hasNewMessageChat$.subscribe((state: any) => {
      this.hasNewChatMessage = state;
    });

    if (!this.authService.hasRole(Role.SystemAdmin) && !this.authService.hasRole(Role.Client)) {
      this.voiceCommsService.startWatching();
      this.voiceCommsService.hasUnread$().subscribe((state) => (this.hasNewVoice = state));
    }
  }

  hasNewVoice = false;

  public getSystemAdminMenu() {
    return [
      {
        title: 'Dashboard',
        icon: 'apps',
        url: '/main/admin',
        role: '',
        active: true,
        onlyUser: false,
      },
      {
        title: 'Manage Client',
        icon: 'people-circle',
        role: '',
        active: true,
        onlyUser: false,
        children: [
          {
            title: 'Client List',
            url: '/main/admin/client-list',
            active: true,
          },
        ],
      },
      {
        title: 'Manage User',
        icon: 'people',
        role: '',
        active: true,
        onlyUser: false,
        children: [
          {
            title: 'User List',
            url: '/main/admin/user-list/user',
            active: true,
          },
          // {
          //   title: 'View events',
          //   url: '/wallet',
          //   active: true,
          // },
          // {
          //   title: 'Suspend / Enable',
          //   url: '/wallet',
          //   active: true,
          // }
        ],
      },
      {
        title: 'Manage Knight',
        icon: 'person-circle',
        role: '',
        active: true,
        onlyUser: false,
        children: [
          {
            title: 'Knight List',
            url: '/main/admin/user-list/knight',
            active: true,
          },
          // {
          //   title: 'View events',
          //   url: '/wallet',
          //   active: true,
          // },
          // {
          //   title: 'View roster',
          //   url: '/wallet',
          //   active: true,
          // },
          // {
          //   title: 'Suspend / Enable',
          //   url: '/wallet',
          //   active: true,
          // }
        ],
      },
      // {
      //   title: 'Settings',
      //   icon: 'settings',
      //   role: '',
      //   active: true,
      //   onlyUser: false,
      //   children: [
      //         {
      //           title: 'Knight Levels and Skills',
      //           url: '/wallet',
      //           active: true,
      //         },
      //         {
      //           title: 'Cancellation period',
      //           url: '/wallet',
      //           active: true,
      //         },
      //         {
      //           title: 'Penalty amounts',
      //           url: '/wallet',
      //           active: true,
      //         },
      //         {
      //           title: 'Lists and Dropdowns',
      //           url: '/wallet',
      //           active: true,
      //         }
      //   ]
      // },
      {
        title: 'Manage Sites',
        icon: 'location',
        role: '',
        active: true,
        onlyUser: false,
        children: [
          // {
          //   title: 'Knight location',
          //   url: '/main/admin/knight-location',
          //   active: true,
          // },
          {
            title: 'Site List',
            url: '/main/admin/event-geofencing',
            active: true,
          },
          {
            title: 'Roster Calendar',
            icon: 'calendar',
            url: '/main/admin/job-calendar',
            role: '',
            active: true,
            onlyUser: false,
          },
        ],
      },
    ];
  }

  public getClientMenu() {
    return [
      {
        title: 'Dashboard',
        icon: 'apps',
        url: '/main/admin',
        role: '',
        active: true,
        onlyUser: false,
      },
      {
        title: 'Manage Staff',
        icon: 'people',
        role: '',
        active: true,
        onlyUser: false,
        children: [
          {
            title: 'User List',
            url: '/main/admin/user-list/staff',
            active: true,
          },
          // {
          //   title: 'View events',
          //   url: '/wallet',
          //   active: true,
          // },
          // {
          //   title: 'Suspend / Enable',
          //   url: '/wallet',
          //   active: true,
          // }
        ],
      },
      {
        title: 'Manage Knight',
        icon: 'person-circle',
        role: '',
        active: true,
        onlyUser: false,
        children: [
          {
            title: 'Knight List',
            url: '/main/admin/user-list/knight',
            active: true,
          },
          // {
          //   title: 'View events',
          //   url: '/wallet',
          //   active: true,
          // },
          // {
          //   title: 'View roster',
          //   url: '/wallet',
          //   active: true,
          // },
          // {
          //   title: 'Suspend / Enable',
          //   url: '/wallet',
          //   active: true,
          // }
        ],
      },
      // {
      //   title: 'Settings',
      //   icon: 'settings',
      //   role: '',
      //   active: true,
      //   onlyUser: false,
      //   children: [
      //         {
      //           title: 'Knight Levels and Skills',
      //           url: '/wallet',
      //           active: true,
      //         },
      //         {
      //           title: 'Cancellation period',
      //           url: '/wallet',
      //           active: true,
      //         },
      //         {
      //           title: 'Penalty amounts',
      //           url: '/wallet',
      //           active: true,
      //         },
      //         {
      //           title: 'Lists and Dropdowns',
      //           url: '/wallet',
      //           active: true,
      //         }
      //   ]
      // },
      {
        title: 'Manage Events',
        icon: 'location',
        role: '',
        active: true,
        onlyUser: false,
        children: [
          // {
          //   title: 'Knight location',
          //   url: '/main/admin/knight-location',
          //   active: true,
          // },
          {
            title: 'Site List',
            url: '/main/admin/event-geofencing',
            active: true,
          },
          {
            title: 'Roster Calendar',
            icon: 'calendar',
            url: '/main/admin/job-calendar',
            role: '',
            active: true,
            onlyUser: false,
          },
        ],
      },
    ];
  }

  get isNewMessage() {
    return (
      (this.hasNewGroupMessage &&
        Object.values(this.hasNewGroupMessage).some((v) => v === true)) ||
      (this.hasNewChatMessage &&
        Object.values(this.hasNewChatMessage).some((v) => v === true))
    );
  }

  public getKnightMenu() {
    return [
      {
        title: 'Home',
        icon: 'home',
        url: '/knight/home',
        role: '',
        active: true,
        onlyUser: false,
      },
      {
        title: 'Chat',
        icon: 'chatbox',
        url: '/knight/chat',
        role: '',
        active: true,
        onlyUser: false,
      },
      {
        title: 'Voice Comms',
        icon: 'mic',
        url: '/knight/ptt',
        role: '',
        active: true,
        onlyUser: false,
      },
      {
        title: 'Profile',
        icon: 'person-circle',
        url: '/knight/profile',
        role: '',
        active: true,
        onlyUser: false,
      },
      // {
      //   title: 'Manage Duty',
      //   icon: 'apps',
      //   role: '',
      //   active: true,
      //   onlyUser: false,
      //   children: [
      //         {
      //           title: 'On Duty',
      //           url: '/wallet',
      //           active: true,
      //         },
      //         {
      //           title: 'Off Duty',
      //           url: '/wallet',
      //           active: true,
      //         }
      //   ]
      // },
      {
        title: 'Schedule',
        icon: 'calendar',
        url: '/knight/schedule',
        role: '',
        active: true,
        onlyUser: false,
      },
      {
        title: 'Leave Request',
        icon: 'calendar',
        url: '/knight/leave',
        role: '',
        active: true,
        onlyUser: false,
      }
      // {
      //   title: 'Switch Company',
      //   icon: 'copy-outline',
      //   url: '/koperasi',
      //   role: '',
      //   active: true,
      //   onlyUser: false,
      // },
      // {
      //   title: 'Events',
      //   icon: 'list',
      //   url: '/knight/event-list',
      //   role: '',
      //   active: true,
      //   onlyUser: false
      // },
      // {
      //   title: 'On Duty (During Event)',
      //   icon: 'settings',
      //   role: '',
      //   active: true,
      //   onlyUser: false,
      //   children: [
      //     {
      //       title: 'Active event',
      //       url: '/knight/event-list',
      //       active: true,
      //     },
      //     {
      //       title: 'Join event',
      //       url: '/knight/example/details-user',
      //       active: true,
      //     },
      //     {
      //       title: 'Meet user',
      //       url: '/wallet',
      //       active: true,
      //     },
      //     {
      //       title: 'Track user location',
      //       url: '/wallet',
      //       active: true,
      //     },
      //     {
      //       title: 'Chat with user',
      //       url: '/wallet',
      //       active: true,
      //     },
      //     {
      //       title: 'Emergency button (call backup)',
      //       url: '/wallet',
      //       active: true,
      //     },
      //     {
      //       title: 'Extend event',
      //       url: '/wallet',
      //       active: true,
      //     },
      //     {
      //       title: 'End early',
      //       url: '/wallet',
      //       active: true,
      //     }
      //   ]
      // }
    ];
  }

  public getInformationMenu() {
    return [
      {
        title: 'Home',
        url: '/main/admin',
        icon: 'home',
        role: '',
        active: true,
        onlyUser: false,
        // children: [
        //       {
        //         title: 'myWallet',
        //         url: '/wallet',
        //         active: true,
        //         // icon: 'podium',
        //         // data: {
        //         //   permission: System.PermissionModuleV2.User.Wallet
        //         // },
        //         // active: this.isApprovedUser() && this.authService.hasActiveMenu([System.PermissionModuleV2.User.Wallet]),
        //       }
        // ]
      },
      {
        title: 'Client',
        url: '/main/admin/client-list',
        icon: 'home',
        role: '',
        active: true,
        onlyUser: false,
      },
      {
        title: 'dashboard',
        url: '/main/admin/dashboard',
        icon: 'home',
        role: '',
        active: true,
        onlyUser: false,
      },
      // {
      //   title: 'Payout',
      //   url: '/admin/payout',
      //   icon: 'card',
      //   role: '',
      //   active: this.authService.hasActiveMenu([System.PermissionModuleV2.Supper.SupperPayout]),
      //   onlyUser: false
      // },
      // {
      //   title: 'Payout',
      //   url: `/admin/payout/${this.authService.currentUserValue.tenantId}`,
      //   icon: 'card',
      //   role: '',
      //   active: this.authService.hasActiveMenuExcludeAccessAll([System.PermissionModuleV2.Koperasi.KopPayout]),
      // },
      // {
      //   title: 'dashboard',
      //   url: '/admin/dashboard',
      //   icon: 'apps',
      //   role: '',
      //   active: this.authService.hasActiveMenuExcludeAccessAll([System.PermissionModuleV2.Koperasi.KopDashboard]),
      //   onlyUser: false
      // },
      // {
      //   title: 'Gold Dashboard',
      //   url: '/gold-dashboard',
      //   icon: 'apps',
      //   role: '',
      //   active: this.authService.hasActiveMenu([System.PermissionModuleV2.User.UserDashboard]) && this.authService.hasStatus(Status.Approved),
      //   onlyUser: true
      // },
      // {
      //   title: 'Product Disclosure',
      //   url: '/product-disclosure',
      //   icon: 'alert-circle',
      //   role: '',
      //   active: this.authService.hasActiveMenu([System.PermissionModuleV2.User.UserDashboard]) && this.authService.hasStatus(Status.Approved),
      //   onlyUser: true
      // },
    ];
  }

  // public getDigitalGoldMenu() {
  //   return [
  //     {
  //       title: 'digitalGold',
  //       icon: 'storefront-outline',
  //       active: this.authService.hasActiveMenuExcludeAccessAll([
  //         System.PermissionModuleV2.User.Wallet,
  //         System.PermissionModuleV2.Koperasi.KopInventory,
  //         System.PermissionModuleV2.Common.MMASSellRequest
  //       ]),
  //       tabIndent: 0,
  //       inlineStye: '',
  //       expanded: false,
  //       className: 'menu-header',
  //       children: [
  //         {
  //           title: 'myWallet',
  //           url: '/wallet',
  //           // icon: 'podium',
  //           data: {
  //             permission: System.PermissionModuleV2.User.Wallet
  //           },
  //           active: this.isApprovedUser() && this.authService.hasActiveMenu([System.PermissionModuleV2.User.Wallet]),
  //         },
  //         {
  //           title: 'myStaking',
  //           url: '/staking-list',
  //           data: {
  //             permission: System.PermissionModuleV2.Koperasi.KopInventory
  //           },
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Koperasi.KopInventory]),
  //         },
  //         {
  //           title: 'emasSellRequest',
  //           url: '/digital-gold/sell-requests',
  //           data: {
  //             permission: System.PermissionModuleV2.Common.MMASSellRequest
  //           },
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Common.MMASSellRequest]),
  //         },
  //       ]
  //     },
  //   ]
  // }

  // public getPhysicalGoldMenu() {
  //   return [
  //     {
  //       title: 'physicalGold',
  //       icon: 'diamond-outline',
  //       active: this.authService.hasActiveMenuExcludeAccessAll([
  //         System.PermissionModuleV2.Koperasi.KopGoldMart,
  //         System.PermissionModuleV2.Koperasi.KopSellRequest,
  //         System.PermissionModuleV2.User.UserShopFront,
  //         System.PermissionModuleV2.User.UserSellRequest,
  //         System.PermissionModuleV2.Common.FullFilment
  //       ]),
  //       tabIndent: 0,
  //       expanded: false,
  //       inlineStye: '',
  //       className: 'menu-header',
  //       children: [
  //         {
  //           title: 'myGoldMart',
  //           url: `/shop-front`,
  //           data: {
  //             permission: System.PermissionModuleV2.User.UserShopFront
  //           },
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.User.UserShopFront])
  //         },
  //         {
  //           title: 'myGoldMart',
  //           url: '/inventory/kop-inventory',
  //           data: {
  //             permission: System.PermissionModuleV2.Koperasi.KopGoldMart
  //           },
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Koperasi.KopGoldMart])
  //         },
  //         {
  //           title: this.isUser ? 'My Purchases' : 'Purchase History',
  //           url: `/physical-gold/fullfillment`,
  //           data: {
  //             permission: System.PermissionModuleV2.Common.FullFilment
  //           },
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Common.FullFilment])
  //         },
  //         {
  //           title: 'mySellRequest',
  //           url: '/physical-gold/admin-listing',
  //           data: {
  //             permissions: [System.PermissionModuleV2.Koperasi.KopSellRequest, System.PermissionModuleV2.User.UserSellRequest]
  //           },
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Koperasi.KopSellRequest])
  //         },
  //         {
  //           title: 'mySellGold',
  //           url: '/physical-gold/user-listing',
  //           // icon: 'shuffle',
  //           data: {
  //             permission: System.PermissionModuleV2.User.UserSellRequest
  //           },
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.User.UserSellRequest])
  //         },
  //       ]
  //     },
  //   ]
  // }

  // public getGlobalSetting() {
  //   return [
  //     {
  //       title: !this.isUser ? 'globalSeting' : 'others',
  //       icon: 'settings-outline',
  //       active: this.isUser || this.authService.hasActiveMenu([
  //         System.PermissionModuleV2.Koperasi.KopGoldRate,
  //         System.PermissionModuleV2.Koperasi.KopMemberManagement,
  //         System.PermissionModuleV2.Koperasi.KopStaffs,
  //         System.PermissionModuleV2.Koperasi.KopGlobalItemSetting,
  //         System.PermissionModuleV2.Common.TransactionHistory,
  //         System.PermissionModuleV2.Common.SupperUserRoles,
  //         System.PermissionModuleV2.Common.KopUsers,
  //         System.PermissionModuleV2.Common.SupperRolePermission
  //       ]),
  //       tabIndent: 0,
  //       inlineStye: '',
  //       className: 'menu-header',
  //       children: [
  //         {
  //           title: 'goldRateSettings',
  //           url: '/admin/gold-rate-setting',
  //           data: {
  //             permission: System.PermissionModule.GoldRate
  //           },
  //           active: this.authService.hasActiveMenuExcludeAccessAll([System.PermissionModuleV2.Koperasi.KopGoldRate])
  //         },
  //         {
  //           title: 'memberManagement',
  //           url: '/admin/member-management',
  //           active: this.authService.hasActiveMenuExcludeAccessAll([System.PermissionModuleV2.Koperasi.KopMemberManagement])
  //         },
  //         {
  //           title: 'staffList',
  //           url: '/admin/user-list/staff',
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Koperasi.KopStaffs])
  //         },
  //         {
  //           title: 'globalItemSetting',
  //           url: '/admin/global-item-setting',
  //           active: this.authService.hasActiveMenuExcludeAccessAll([System.PermissionModuleV2.Koperasi.KopGlobalItemSetting])
  //         },
  //         {
  //           title: 'transactionHistory',
  //           url: '/admin/transaction-history',
  //           active: this.authService.hasActiveMenuExcludeAccessAll([System.PermissionModuleV2.Common.TransactionHistory]) && (this.isApprovedUser() || !this.isUser) ,
  //         },
  //         {
  //           title: 'switchKoperasi',
  //           url: '/switch-koperasi',
  //           active: this.authService.hasRole(Role.User)
  //         },
  //         {
  //           title: 'userRoles',
  //           url: '/admin/user-role',
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Common.SupperUserRoles]),
  //         },
  //         {
  //           title: 'User List',
  //           url: '/admin/user-list/user',
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Common.KopUsers]),
  //         },
  //         {
  //           title: 'rolePermissions',
  //           url: '/admin/role-permissions',
  //           active: this.authService.hasPermissions([System.PermissionModuleV2.Common.SupperRolePermission]),
  //         }
  //       ]
  //     },
  //     {
  //       title: 'coopManagement',
  //       icon: 'people-circle-outline',
  //       active: !this.isUser && this.authService.hasActiveMenu([
  //         System.PermissionModuleV2.Common.SupperTenants,
  //         System.PermissionModuleV2.Common.SupperMemberUpload,
  //       ]),
  //       tabIndent: 0,
  //       inlineStye: '',
  //       className: 'menu-header',
  //       children: [
  //         {
  //           title: 'tenantList',
  //           url: '/admin/tenant-list',
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Common.SupperTenants]),
  //         },
  //         {
  //           title: 'createTenant',
  //           url: '/admin/create-tenant',
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Common.SupperTenants]),
  //         },
  //         {
  //           title: 'Upload Member',
  //           url: '/admin/member-upload',
  //           active: this.authService.hasActiveMenu([System.PermissionModuleV2.Common.SupperMemberUpload]),
  //         },
  //         {
  //           title: 'Assign M-MAS BSE 999.9',
  //           url: '/digital-gold/assign/999',
  //           icon: 'paper-plane',
  //           role: '',
  //           active: this.authService.hasActiveMenu([System.PermissionModule.AccessAll]),
  //           onlyUser: false
  //         }
  //       ]
  //     }
  //   ]
  // }

  async onLogout() {
    const alert = await this.alertCtrl.create({
      header: this.translateService.getTranslation('Log out'),
      message: this.translateService.getTranslation(
        'Are you sure you want to log out?'
      ),
      subHeader: '',
      cssClass: 'info-dialog',
      buttons: [
        {
          text: this.translateService.getTranslation('cancelBtn'),
          role: 'cancel',
          handler: () => {},
        },
        {
          text: this.translateService.getTranslation('yes'),
          handler: () => {
            this.userService.logout().subscribe(async () => {
              // this.router.navigateByUrl('/login');
              this.authService.logout();
              // await this.signalRService.stopConnection();
            }, (error) => {
              this.authService.logout();
            });
          },
        },
      ],
    });
    await alert.present();
  }

  handleSelectLang() {
    // this.modalController.create({
    //   component: LanguageComponent,
    //   cssClass: 'modal-height',
    //   componentProps: {
    //     data: {
    //     }
    //   }
    // }).then(modal => {
    //   modal.onDidDismiss().then(res => {
    //     if (res && res.data) {
    //       this.languages = environment.languages.find(x => x.code == res.data);
    //       this.lang = res.data
    //     }
    //   });
    //   modal.present();
    // });
  }

  private isApprovedUser() {
    return true;
    //return this.authService.hasRole(Role.User) && this.authService.hasStatus(Status.Approved);
  }

  private get isSuperAdmin() {
    return this.authService.hasRole(Role.SuperAdmin);
  }

  private get isUser() {
    return false;
    //return this.authService.hasRole(Role.User);
  }

  private get isKoperasi() {
    return false; //return this.authService.hasRole(Role.Koperasi);
  }

  private get isKoperasiAdmin() {
    return false; //return this.authService.hasRole(Role.KoperasiAdmin)
  }

  private get isKoperasiStaff() {
    return false; //return this.authService.hasRole(Role.KoperasiStaff)
  }

  private get isProductOwner() {
    return false; //return this.authService.hasRole(Role.ProdOwner);
  }

  private get isProductAdmin() {
    return false; //return this.authService.hasRole(Role.ProdAdmin);
  }

  private get isSystemAdmin() {
    return false; //return this.authService.hasRole(Role.SystemAdmin);
  }

  public hasPermission(module: any) {
    // if (!module) return true;
    // return this.authService.hasPermission(module)
    return false; //
  }

  goto(url: string) {
    this.router.navigateByUrl(url);
  }

  onThemeSelected(selectedTheme: string) {
    this.themeSelected.emit(selectedTheme);
  }

  async goLiveVideo(){
    const alert = await this.alertCtrl.create({
      header: this.translateService.getTranslation('Live Stream'),
      message: this.translateService.getTranslation(
        'Do you really want to start a live stream?'
      ),
      subHeader: '',
      cssClass: 'info-dialog',
      buttons: [
        {
          text: this.translateService.getTranslation('cancelBtn'),
          role: 'cancel',
          handler: () => {},
        },
        {
          text: this.translateService.getTranslation('yes'),
          handler: () => {
            this.action.emit('LiveStream');
          },
        },
      ],
    });
    await alert.present();
  }
}
